(function ($) {
	let faqItem = null,
		footerMenuTitle = null,
		mobileArrow = null,
		heroItem = null,
		heroCarouselThumbnails = null,
		inactivePage = null,
		viewAllCard = null;

	casino = {
		viewAllPosts: function(card){
			if (card) {
				card.click(function(event) {
					event.preventDefault();
					window.location = $(this).find('.btn')[0].href;
				});
			}
		},
		setScrollbarWidth: function () {
			// Creating invisible container
			const outer = document.createElement('div');
			outer.style.visibility = 'hidden';
			outer.style.overflow = 'scroll'; // forcing scrollbar to appear
			outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
			document.body.appendChild(outer);

			// Creating inner element and placing it in the container
			const inner = document.createElement('div');
			outer.appendChild(inner);

			// Calculating difference between container's full width and the child width
			const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

			// Removing temporary elements from the DOM
			outer.parentNode.removeChild(outer);

			$(':root').css('--scrollbar-width', `${scrollbarWidth}px`, '0px');
		},
		initCarousel: function (item, thumbnails) {
			if (item && thumbnails) {
				item.addClass('active');
				thumbnails.first().addClass('active');
				thumbnails.first().attr('aria-current', 'true');
			}
		},
		fixCarouselThumbnailsActive: function (thumbnail) {
			if (thumbnail) {
				thumbnail.on('click', function () {
					thumbnail.not($(this)).each(function () {
						$(this).removeClass('active');
					});
					$(this).addClass('active');
				});
			}
		},
		faqCollapse: function (item) {
			item.on('click', function (event) {
				let answer = $(this).children('.schema-faq-answer');

				event.preventDefault();
				answer.slideToggle();
				answer.toggleClass('show');
				answer.parent(faqItem).toggleClass('open');
			});
		},
		disableLinkClick: function (item) {
			item.on('click', function (event) {
				event.preventDefault();
			});
		},
		mobileArrowClick: function (item) {
			item.on('click', (function (event) {
				event.preventDefault();
				$(this).toggleClass('rotate');
				$(this).parents(':eq(1)').toggleClass('dropdown-show');
				$(this).parents(':eq(1)').children('.dropdown-menu').slideToggle();
			}));
		},
		hideCtaButtons: function (inactivePage) {
			if (inactivePage) {
				$('a').each(function(){
					if($(this).attr('href').indexOf('/go/') >= 0) {
						$(this).hide();
					}
				});
			}
		},
		variableInit: function () {
			faqItem = $('.schema-faq-section');
			footerMenuTitle = $('.footer-menu').children('li').children('a');
			mobileArrow = $('.mobile-arrow');
			heroItem = $('#carouselHero .carousel-item').first().length > 0 ? $('#carouselHero .carousel-item').first() : null;
			heroCarouselThumbnails = $('header .indicators-wrapper button').length > 0 ? $('header .indicators-wrapper button') : null;
			inactivePage = $('header.casino-inactive').length > 0 ? $('eader.casino-inactive') : null;
			viewAllCard = $('.latest-posts-wrapper .view-all').length > 0 ? $('.latest-posts-wrapper .view-all') : null;
		},
		init: function () {
			this.setScrollbarWidth();
			this.variableInit();
			this.faqCollapse(faqItem);
			this.disableLinkClick(footerMenuTitle);
			this.mobileArrowClick(mobileArrow);
			this.initCarousel(heroItem, heroCarouselThumbnails);
			this.fixCarouselThumbnailsActive(heroCarouselThumbnails);
			this.hideCtaButtons(inactivePage);
			this.viewAllPosts(viewAllCard);
		},
	};
	casino.init();
}(jQuery));